// a library to wrap and simplify api calls
import apisauce from 'apisauce'
import Constant from '../../library/Constant'

const create = (api_key) => {
    let api;
    // const baseURL = `${Constant.URL_TEST}`
    const baseURL = `${Constant.API_BASE_URL_PROD}`
    const x_api_key = localStorage.getItem(Constant.API_KEY)
    const key = api_key !== undefined && api_key !== 'REPORT' ? api_key : x_api_key
    api = apisauce.create({
        baseURL,
        headers: {
            'X-API-KEY': key,
            'access-token': Constant.token
        },
        // 30 second timeout...
        timeout: 300000 // timeout mamenit..
    })

    api.addAsyncRequestTransform(request => async () => {
        var token
        try {
            const res = await localStorage.getItem(Constant.ACCESS_TOKEN)
            if (token != null) {
                token = res
            } else {
                token = res
            }
        } catch (error) {
        }
        request.headers['Authorization'] = `Bearer ${token}`
        if (api_key === 'REPORT') {
            request.responseType = 'blob'
        }
    })

    const getRoot = () => api.get('')

    //AUTH
    // const checkApiKey = (body) => api.post('api-key', body)
    const checkApiKey = (body) => api.post(`${Constant.API_VERSION_1}/admin/api-key`, body)
    const login = (body) => api.post(`${Constant.API_VERSION_1}/admin/login`, body)
    const logout = () => api.get(`${Constant.API_VERSION_1}/admin/logout`)
    const accessMenu = () => api.get(`${Constant.API_VERSION_1}/admin/access-menu`)
    const refreshToken = (body) => api.post(`${Constant.API_VERSION_1}/admin/refresh-token`, body)
    const getProfile = () => api.get(`${Constant.API_VERSION_1}/admin/profile`)
    const forgotPass = (body) => api.post(`${Constant.API_VERSION_1}/admin/forgot-password`, body)
    const resetPass = (body) => api.post(`${Constant.API_VERSION_1}/admin/reset-password`, body)
    const getPermission = (id) => api.get(`${Constant.API_VERSION_1}/admin/menu-permission/${id}`)

    //HOSPITAL
    const getDetailHospital = () => api.get(`${Constant.API_VERSION_1}/admin/hospital/detail`)

    //DASHBOARD
    const getDashboardTransaksi = (month, year) => api.get(`${Constant.API_VERSION_1}/admin/dashboard/transaction?month=${month}&year=${year}`)
    const getDashboardReview = (month, year) => api.get(`${Constant.API_VERSION_1}/admin/dashboard/queue-review?month=${month}&year=${year}`)

    //PROMO
    const getPromo = () => api.get(`${Constant.API_VERSION_1}/admin/promotion/list`)
    const createPromo = (body) => api.post(`${Constant.API_VERSION_1}/admin/promotion/create`, body)

    //ROOM
    const getRoom = () => api.get(`${Constant.API_VERSION_1}/admin/room`)
    const getRoomFilter = (param) => api.get(`${Constant.API_VERSION_1}/admin/room?${param}`)
    const getRoomFilterbyBuilding = (param) => api.get(`${Constant.API_VERSION_1}/admin/room?filter={${param}}`)
    const getBuilding = () => api.get(`${Constant.API_VERSION_1}/admin/building`)
    const getBuildingFilter = (param) => api.get(`${Constant.API_VERSION_1}/admin/building?${param}`)
    const createBuilding = (body) => api.post(`${Constant.API_VERSION_1}/admin/building/create`, body)
    const getDetailBuilding = (id) => api.get(`${Constant.API_VERSION_1}/admin/building/detail?id=${id}`)
    const updateBuilding = (body) => api.post(`${Constant.API_VERSION_1}/admin/building/edit`, body)
    const createRoom = (body) => api.post(`${Constant.API_VERSION_1}/admin/room/create`, body)
    const getDetailRoom = (id) => api.get(`${Constant.API_VERSION_1}/admin/room/detail?id=${id}`)
    const changeStatusRoom = (body) => api.post(`${Constant.API_VERSION_1}/admin/room/edit`, body)
    const updateRoom = (body) => api.post(`${Constant.API_VERSION_1}/admin/room/edit`, body)
    const checkRoom = (id) => api.get(`${Constant.API_VERSION_1}/admin/room/check?id=${id}`)
    const changeRoomSchedule = (roomID, date, timeStart, timeEnd) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedule/room?room_id=${roomID}&schedule_date=${date}&time_start=${timeStart}&time_end=${timeEnd}`)

    //PEMBAYARAN / TRANSAKSI
    const getPembayaran = () => api.get(`${Constant.API_VERSION_1}/admin/payment/monitoring/list`);
    const getPembayaranDetail = (id) => api.get(`${Constant.API_VERSION_1}/admin/payment/monitoring/detail?id=${id}`)
    const findCode = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/findcode`, body)

    //AKUN
    const getAkun = () => api.get(`${Constant.API_VERSION_1}/admin/user`);
    const detailAkun = (id) => api.get(`${Constant.API_VERSION_1}/admin/user/detail?id=${id}`)
    const editAkun = (body) => api.post(`${Constant.API_VERSION_1}/admin/user/edit`, body)

    const getUser = () => api.get(`${Constant.API_VERSION_1}/admin/account/list`)
    const getUserDetail = (id) => api.get(`${Constant.API_VERSION_1}/admin/account/list/${id}`)
    const updateUser = (body) => api.post(`${Constant.API_VERSION_1}/admin/account/update`, body)
    const changeStatusUser = (body) => api.post(`${Constant.API_VERSION_1}/admin/account/change-status`, body)
    const createUser = (body) => api.post(`${Constant.API_VERSION_1}/admin/account/create`, body)

    //SPESIALIS
    const getListSpesialis = () => api.get(`${Constant.API_VERSION_1}/admin/specialities`)
    const createSpesialis = (body) => api.post(`${Constant.API_VERSION_1}/admin/specialities/create`, body)

    //SCRENNING
    const getScrenning = () => api.get(`${Constant.API_VERSION_1}/admin/master/screening`);
    const getFormScrenning = () => api.get(`${Constant.API_VERSION_1}/admin/screening/form`);
    const getTransactionScrenning = () => api.get(`${Constant.API_VERSION_1}/admin/screening/result`)
    const getHistoryTransactionScrenning = () => api.get(`${Constant.API_VERSION_1}/admin/screening/history`)
    const getTransactionScrenningFilter = (params) => api.get(`${Constant.API_VERSION_1}/admin/screening/result?${params}`)
    const updateTemperature = (body) => api.post(`${Constant.API_VERSION_1}/admin/screening/temperature`, body)
    const getTransactionScrenningDetail = (id) => api.get(`${Constant.API_VERSION_1}/admin/screening/result/${id}`)
    const createScrenning = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/screening`, body)
    const submitScrenning = (body) => api.post(`${Constant.API_VERSION_1}/admin/screening/create`, body)
    const updateScrenning = (body) => api.post(`${Constant.API_VERSION_1}/admin/screening/update`, body)
    const getDetailScrenning = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/screening/${id}`)

    //POLI
    const getListMasterPoli = () => api.get(`${Constant.API_VERSION_1}/admin/polyclinic/list`)
    const getListMasterPoliActive = (param) => api.get(`${Constant.API_VERSION_1}/admin/polyclinic/list?${param}`)
    const getListPoli = (keyword) => api.get(`${Constant.API_VERSION_1}/admin/polyclinic/list${keyword}`)
    const getPoliSchedule = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/polyclinic/schedule?id=${id}`);
    const getDetailPoli = (id) => api.get(`${Constant.API_VERSION_1}/admin/polyclinic/detail?is_admin=1&id=${id}`)
    const createPoli = (body) => api.post(`${Constant.API_VERSION_1}/admin/polyclinic/create`, body)
    const updatePoli = (body) => api.post(`${Constant.API_VERSION_1}/admin/polyclinic/edit`, body)
    const updateSchedulePoli = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/polyclinic/schedule/edit`, body)
    const createPoliSchedule = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/polyclinic/schedule/create`, body)
    const getSchedulePoliTransactionFilter = (param) => api.get(`${Constant.API_VERSION_1}/admin/polyclinic/schedule/list?date_filter={"schedule_date": {${param}}}`)
    const getJadwalTransaksiFilter = (key) => api.get(`${Constant.API_VERSION_1}/admin/polyclinic/schedule/list?${key}`)
    const createSessionPoli = (body) => api.post(`${Constant.API_VERSION_1}/admin/polyclinic/schedule/create`, body)
    const checkPoliklinik = (id) => api.get(`${Constant.API_VERSION_1}/admin/polyclinic/check?id=${id}`)
    const editSchedulePoli = (body) => api.post(`${Constant.API_VERSION_1}/admin/polyclinic/schedule/edit`, body)

    //DOKTER
    const createDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/create`, body)
    const updateDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/edit`, body)
    const createDokterSchedule = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/doctor/schedule/create`, body)
    const createManualCron = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/schedule/manual`, body)
    const createManualCronHFIS = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/schedule/bpjs/update`, body)
    const getDetailDokter = (id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/detail?id=${id}`)
    const uploadFoto = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/upload/photo`, body)
    const getDokterScheduleByPoli = (id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedule?polyclinic_id=${id}`)
    const getListDokter = () => api.get(`${Constant.API_VERSION_1}/admin/doctor/list`)
    const getListDokterFilter = (params) => api.get(`${Constant.API_VERSION_1}/admin/doctor/list?${params}`)
    const getSpesialisDokter = (keyword) => api.get(`${Constant.API_VERSION_1}/admin/specialities${keyword}`)
    const getListSpesialisDokter = () => api.get(`${Constant.API_VERSION_1}/admin/specialities`)
    const getDokterSchedule = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/doctor/schedule?filter={"doctor_detail_id":${id}}`);
    const getDokterScheduleId = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/doctor/schedule?filter={"id":${id}}`);
    const getScheduleTransaction = () => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedules`)
    const getScheduleTransactionFilter = (param) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedules?date_filter={"schedule_date": {${param}}}`)
    const getScheduleTransactionFilterByDoctorID = (id, param) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedules?filter={"doctor_id":[${id}]}&date_filter={"schedule_date": {${param}}}`)
    const getScheduleTransactionFilterName = (param) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedules?keyword=${param}`)
    const getScheduleTransactionFilterNameAndDate = (nama, param) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedules?keyword=${nama}&date_filter={"schedule_date": {${param}}}`)
    const updateSessionDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/session/doctor/update`, body)
    const batalSessionDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/schedule/detail/edit`, body)
    const createSessionDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/schedule/create`, body)
    const checkDokter = (id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/check?id=${id}`)
    const batalTransaksiJadwal = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/schedule/edit`, body)
    const editMasterJadwal = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/doctor/schedule/edit`, body)
    const createJadwalCuti = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/schedule/leave`, body)
    const updateCatatanDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/detail/edit`, body)
    const getLastScheduleDokter = (param) => api.get(`${Constant.API_VERSION_1}/admin/master/doctor/schedule/latest?${param}`)
    const createDraftScheduleDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/doctor/schedule/draft`, body)
    const editDraftScheduleDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/doctor/schedule/drafts/edit`, body)
    const getMasterDraftScheduleDokter = () => api.get(`${Constant.API_VERSION_1}/admin/master/doctor/schedule/draft`)
    const createMasterScheduleFromDraft = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/doctor/schedule/draft/create`, body)
    const downloadScheduleDokter = (param) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedule/download?${param}`)

    //RESERVASI DOKTER
    const getReservasiDokter = () => api.get(`${Constant.API_VERSION_2}/admin/appointment/list`)
    const getReservasiDokterByBookingID = (booking_id) => api.get(`${Constant.API_VERSION_2}/admin/appointment/list?filter={"booking_id": ${booking_id}}`)
    const getReservasiDokterFilter = (param) => api.get(`${Constant.API_VERSION_2}/admin/appointment/list?${param}`)
    const getDetailReservasiDokter = (id) => api.get(`${Constant.API_VERSION_1}/admin/appointment/detail/${id}`)
    const getDetailKuitansi = (id) => api.get(`${Constant.API_VERSION_1}/admin/payment/kuitansi?id=${id}`)
    const filterReservasiDokter = (params) => api.get(`${Constant.API_VERSION_2}/admin/appointment/list?${params}`)
    const filterDokter = (params) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedules?${params}`)
    const getTimeslotDokter = (id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedules/detail?id=${id}`)
    const getTimeSlot = (param) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedule?${param}`)
    const createReservation = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/create`, body)
    const cancelReservation = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/cancel`, body)
    const emergencyReservation = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/emergency/update`, body)
    const checkIn = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/checkin`, body)
    const reschedule = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/reschedule`, body)
    const addNotes = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/notes/create`, body)
    const getLocationRegis = (id) => api.get(`${Constant.API_VERSION_1}/admin/appointment/registration/location/${id}`)
    const getPrintSEP = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/sep`, body)
    const postUpdateSEP = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/sep/get`, body)
    const getAppointmeentByDate = (body) => api.get(`${Constant.API_VERSION_2}/admin/appointment/list?date_filter=${body}&is_download=1`)
    const getScheduleSession = () => api.get(`${Constant.API_VERSION_1}/admin/doctor/session/time`)


    const getListAsuransi = (noRM, withInsurance) => api.get(`${Constant.API_VERSION_1}/admin/master/patient/insurance?medical_record_no=${noRM}&is_admin=1${withInsurance}`)
    const getListProvider = () => api.get(`${Constant.API_VERSION_1}/admin/integration/provider/list`)
    const getCategoryProvider = () => api.get(`${Constant.API_VERSION_1}/admin/integration/provider/type/list`)
    const getProviderByCategory = (type) => api.get(`${Constant.API_VERSION_1}/admin/integration/provider/list?type=${type}`)
    const getProviderByCode = (body) => api.post(`${Constant.API_VERSION_1}/admin/integration/provider/detail`, body)
    // const getProviderByCode = (code) => api.get(`integration/provider/detail?business_partner_code=${code}`)

    // ROLE
    const getListMenu = () => api.get(`${Constant.API_VERSION_1}/admin/menu/list`)
    const getListRole = () => api.get(`${Constant.API_VERSION_1}/admin/roles/list`)
    const createRole = (body) => api.post(`${Constant.API_VERSION_1}/admin/roles/create`, body)
    const getDetailRole = (id) => api.get(`${Constant.API_VERSION_1}/admin/roles/list/${id}`)
    const updateRole = (body) => api.post(`${Constant.API_VERSION_1}/admin/roles/update`, body)
    const changeStatusRole = (body) => api.post(`${Constant.API_VERSION_1}/admin/roles/change-status`, body)

    // PATIENT
    const getListPatient = () => api.get(`${Constant.API_VERSION_1}/admin/master/patient/list`)
    const getListPatientFilter = (params) => api.get(`${Constant.API_VERSION_1}/admin/master/patient/list?${params}`)
    const createPatient = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/patient/create`, body)
    const getDetailPatient = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/patient/detail/${id}`)
    const updatePatient = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/patient/edit`, body)
    const changeStatusPatient = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/patient/changestatus`, body)
    const searchPatientIntegration = (param) => api.get(`${Constant.API_VERSION_1}/admin/master/patient/integration?${param}`)
    const searchPatientIntegrationByNoRM = (param) => api.get(`${Constant.API_VERSION_1}/admin/master/patient/integration/byRmNo?${param}`)
    const getNoRM = () => api.get(`${Constant.API_VERSION_1}/admin/master/patient/generate-medical-record`)

    // FASILITAS
    const createManualCronFasilitas = () => api.get(`${Constant.API_VERSION_1}/admin/facility/schedule/manual`)
    const getAllFacility = () => api.get(`${Constant.API_VERSION_1}/admin/master/facility/list`)
    const getAllFacilityFilter = (key) => api.get(`${Constant.API_VERSION_1}/admin/master/facility/list?keyword=${key}`)
    const getMasterSchedule = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/facility/schedule?id=${id}`)
    const getDetailFacility = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/facility/detail/${id}`)
    const createFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/facility/create`, body)
    const updateScheduleFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/facility/schedule/edit`, body)
    const changeStatusFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/facility/changestatus`, body)
    const updateFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/facility/edit`, body)
    const createMasterSchedule = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/facility/schedule/create`, body)
    const getFacilityCategory = () => api.get(`${Constant.API_VERSION_1}/admin/master/facility/category/list`)
    const getFacilityByCategoriID = (category) => api.get(`${Constant.API_VERSION_1}/admin/master/facility/list?filter={"facility_category_name": "${category}"}`)
    const getSubFacilityByFacilityID = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/subfacility/list?facility_id=${id}&filter={"status": 1}`)
    const getListSessionFacilityByCategory = (cat) => api.get(`${Constant.API_VERSION_1}/admin/facility/session/list?facility_category=${cat}`)

    // SUB FASILITAs
    const getAllSubFacility = () => api.get(`${Constant.API_VERSION_1}/admin/master/subfacility/list`)
    const getDetailSubFacility = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/subfacility/detail/${id}`)
    const createSubFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/subfacility/create`, body)
    const changeStatusSubFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/subfacility/changestatus`, body)
    const updateSubFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/subfacility/edit`, body)
    const getDefaultSubFacility = () => api.get(`${Constant.API_VERSION_1}/admin/master/subfacility/list?filter={"status": 1, "is_default": 1}`)
    const getEksternalCodeSubFacility = () => api.get(`${Constant.API_VERSION_1}/admin/master/subfacility/code/list`)

    // PEMANGGILAN
    const updateListAntrian = (body) => api.post(`${Constant.API_VERSION_1}/admin/queue/doctor/update`, body)
    const getListAntrian = (doctorID, scheduleID) => api.get(`${Constant.API_VERSION_1}/admin/queue/doctor/list?doctor_id=${doctorID}&doctor_schedule_id=${scheduleID}`)
    const getListAntrianByPage = (doctorID, scheduleID, page, limit) => api.get(`${Constant.API_VERSION_1}/admin/queue/doctor/list?doctor_id=${doctorID}&doctor_schedule_id=${scheduleID}&page=${page}&per_page=${limit}`)
    const getListAntrianSkip = (doctorID, scheduleID) => api.get(`${Constant.API_VERSION_1}/admin/queue/doctor/list?doctor_id=${doctorID}&doctor_schedule_id=${scheduleID}&show_only_status=[2,5]`)
    const getListAntrianSkipByPage = (doctorID, scheduleID, page, limit) => api.get(`${Constant.API_VERSION_1}/admin/queue/doctor/list?doctor_id=${doctorID}&doctor_schedule_id=${scheduleID}&show_only_status=[2,5]&page=${page}&per_page=${limit}`)
    const getDetailPasienPemanggilan = (id, scheduleID) => api.get(`${Constant.API_VERSION_1}/admin/queue/doctor/detail?patient_id=${id}&doctor_schedule_detail_id=${scheduleID}`)
    const getDokterByKeyword = (keyword) => api.get(`${Constant.API_VERSION_1}/admin/doctor/queue/list?keyword=${keyword}`)
    const getDokterByKeywordAndPoli = (keyword, id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/queue/list?keyword=${keyword}&filter={"polyclinic_id":[${id}]}`)
    const notificationAntrian = () => api.get(`${Constant.API_VERSION_1}/admin/queue/notification`)

    //FARMASI PRODUKSI
    const getPharmacyProduction = () => api.get(`${Constant.API_VERSION_1}/admin/pharmacy/production/list`)
    const getPharmacyProductionByFacilityID = (id) => api.get(`${Constant.API_VERSION_1}/admin/pharmacy/production/list?facility_id=${id}`)
    const changeStatusProduksi = (body) => api.post(`${Constant.API_VERSION_1}/admin/pharmacy/production/changestatus`, body)
    const getPharmacySession = () => api.get(`${Constant.API_VERSION_1}/admin/pharmacy/session/list`)
    const updateSession = (body) => api.post(`${Constant.API_VERSION_1}/admin/session/facility/update`, body)
    const getDetailPharmacyProduction = (id) => api.get(`${Constant.API_VERSION_1}/admin/pharmacy/production/detail/${id}`)
    const updateCountPrint = (body) => api.post(`${Constant.API_VERSION_1}/admin/pharmacy/production/count-print`, body)

    // QUEUE DISPLAY
    const getAllQueueDisplay = () => api.get(`${Constant.API_VERSION_1}/admin/tvdisplay`)
    const getDetailQueueDisplay = (id) => api.get(`${Constant.API_VERSION_1}/admin/tvdisplay/detail?id=${id}`)
    const createQueueDisplay = (body) => api.post(`${Constant.API_VERSION_1}/admin/tvdisplay/create`, body)
    const updateQueueDisplay = (body) => api.post(`${Constant.API_VERSION_1}/admin/tvdisplay/edit`, body)
    const changeStatusQueueDisplay = (body) => api.post(`${Constant.API_VERSION_1}/admin/tvdisplay/changestatus`, body)

    //KIOSK DISPLAY
    const getAllKioskDisplay = () => api.get(`${Constant.API_VERSION_1}/admin/kiosk/display/queue`)
    const getDetailKiosk = (id) => api.get(`${Constant.API_VERSION_1}/admin/kiosk/display/queue/detail?id=${id}`)
    const updateKioskDisplay = (body) => api.post(`${Constant.API_VERSION_1}/admin/kiosk/display/queue/edit`, body)
    const createKioskDisplay = (body) => api.post(`${Constant.API_VERSION_1}/admin/kiosk/display/queue/create`, body)
    const changeStatusKioskDisplay = (body) => api.post(`${Constant.API_VERSION_1}/admin/kiosk/display/queue/changestatus`, body)

    const getPemanggilanFacility = (id) => api.get(`${Constant.API_VERSION_1}/admin/queue/facility/list?facility_id=${id}`)
    const getPemanggilanFacilitySkip = (id) => api.get(`${Constant.API_VERSION_1}/admin/queue/facility/list?facility_id=${id}&show_only_status=5`)
    const updateListPemanggilanFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/queue/facility/update`, body)
    const getDetailPemanggilanFacility = (id) => api.get(`${Constant.API_VERSION_1}/admin/queue/facility/detail?facility_queue_id=${id}`)
    const getListDokterPemanggilan = () => api.get(`${Constant.API_VERSION_1}/admin/doctor/queue/list`)
    const updateListPemanggilanFacilityCounter = (body) => api.post(`${Constant.API_VERSION_1}/admin/queue/facility/update/counter`, body)

    const getListCounter = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/facility/detail/${id}`)
    const getListAllCounter = () => api.get(`${Constant.API_VERSION_1}/admin/master/counter/list?page=1&per_page=10`)
    const getListCounterByPage = (page) => api.get(`${Constant.API_VERSION_1}/admin/master/counter/list?page=${page}&per_page=10`)
    const getListCounterByFilter = (filter) => api.get(`${Constant.API_VERSION_1}/admin/master/counter/list?filter={filter}`)
    const getListCounterBySearch = (param) => api.get(`${Constant.API_VERSION_1}/admin/master/counter/list?keyword=${param}`)
    const getListSubFacility = (id) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/list?sub_facility_id=${id}`)
    const getListSubFacilityByPage = (id, page, limit) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/list?sub_facility_id=${id}&page=${page}&per_page=${limit}`)
    const getDetailListSubFacility = (id) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/detail?sub_facility_queue_id=${id}`)
    const getPemanggilanSubFacilitySkip = (id) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/list?facility_id=${id}&show_only_status=[2,5]`)
    const getPemanggilanSubFacilitySkipByPage = (id, page, limit) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/list?facility_id=${id}&show_only_status=[2,5]&page=${page}&per_page=${limit}`)
    const updateListPemanggilanSubFacility = (body) => api.post(`${Constant.API_VERSION_1}/admin/queue/subfacility/update`, body)
    const updateListPemanggilanSubFacilityCounter = (body) => api.post(`${Constant.API_VERSION_1}/admin/queue/subfacility/update/counter`, body)
    const createCounter = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/counter/create`, body)
    const updateCounter = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/counter/edit`, body)
    const getDetailCounter = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/counter/detail/${id}`)
    const changeStatusCounter = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/counter/changestatus`, body)

    // PARAMETER
    const getParameter = () => api.get(`${Constant.API_VERSION_1}/admin/param/list`)
    const updateParameter = (body) => api.post(`${Constant.API_VERSION_1}/admin/param/edit`, body)

    // FAQ
    const getCategoryFAQ = () => api.get(`${Constant.API_VERSION_1}/admin/faq/get-category`)
    const createCategoryFAQ = (body) => api.post(`${Constant.API_VERSION_1}/admin/faq/create-category`, body)
    const getDetailCategoryFAQ = (id) => api.get(`${Constant.API_VERSION_1}/admin/faq/get-category/${id}`)
    const updateCategoryFAQ = (body) => api.post(`${Constant.API_VERSION_1}/admin/faq/update-category`, body)
    const getCategoryFAQByType = (type) => api.get(`${Constant.API_VERSION_1}/admin/faq/get-category?type=${type}`)
    const createFAQ = (body) => api.post(`${Constant.API_VERSION_1}/admin/faq/create`, body)
    const getFAQ = () => api.get(`${Constant.API_VERSION_1}/admin/faq/get`)
    const getDetailFAQ = (id) => api.get(`${Constant.API_VERSION_1}/admin/faq/get/${id}`)
    const updateFAQ = (body) => api.post(`${Constant.API_VERSION_1}/admin/faq/update`, body)

    // TNC
    const getTNC = () => api.get(`${Constant.API_VERSION_1}/admin/tnc`)
    const getDetailTNC = (id) => api.get(`${Constant.API_VERSION_1}/admin/tnc/detail?id=${id}`)
    const getPreviewTNC = () => api.get(`${Constant.API_VERSION_1}/admin/tnc/get`)
    const createTNC = (body) => api.post(`${Constant.API_VERSION_1}/admin/tnc/create`, body)
    const updateTNC = (body) => api.post(`${Constant.API_VERSION_1}/admin/tnc/edit`, body)

    // POLICY
    const getPolicy = () => api.get(`${Constant.API_VERSION_1}/admin/policy`)
    const getDetailPolicy = (id) => api.get(`${Constant.API_VERSION_1}/admin/policy/detail?id=${id}`)
    const getPreviewPolicy = () => api.get(`${Constant.API_VERSION_1}/admin/policy/get`)
    const createPolicy = (body) => api.post(`${Constant.API_VERSION_1}/admin/policy/create`, body)
    const updatePolicy = (body) => api.post(`${Constant.API_VERSION_1}/admin/policy/edit`, body)

    // PROMOSI
    const getPromosi = () => api.get(`${Constant.API_VERSION_1}/admin/promotion/list`)
    const createPromosi = (body) => api.post(`${Constant.API_VERSION_1}/admin/promotion/create`, body)
    const getDetailPromosi = (id) => api.get(`${Constant.API_VERSION_1}/admin/promotion/detail/${id}`)
    const updatePromosi = (body) => api.post(`${Constant.API_VERSION_1}/admin/promotion/update`, body)

    // MEDIA PROMOSI
    const getListMedia = () => api.get(`${Constant.API_VERSION_1}/admin/promotion/media/list`)
    const createMedia = (body) => api.post(`${Constant.API_VERSION_1}/admin/promotion/media/create`, body)
    const getDetailMedia = (id) => api.get(`${Constant.API_VERSION_1}/admin/promotion/media/detail/${id}`)
    const updateMedia = (body) => api.post(`${Constant.API_VERSION_1}/admin/promotion/media/update`, body)

    // HISTORY
    const getAllHistory = (id) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/history?facility_category_id=${id}`)
    const getAllHistoryName = (name) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/history?facility_category_name=${name}`)
    const getAllHistoryNameByDate = (name, from, to) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/history?facility_category_name=${name}&start_date=${from}&end_date=${to}`)
    const getAllHistoryByDate = (id, from, to) => api.get(`${Constant.API_VERSION_1}/admin/queue/subfacility/history?facility_category_id=${id}&start_date=${from}&end_date=${to}`)
    const getHistoryDoctor = () => api.get(`${Constant.API_VERSION_1}/admin/queue/doctor/history`)
    const getHistoryDoctorByPage = (page, limit) => api.get(`${Constant.API_VERSION_1}/admin/queue/doctor/history?page=${page}&per_page=${limit}`)
    const getHistoryDoctorByDate = (from, to) => api.get(`${Constant.API_VERSION_1}/admin/queue/doctor/history?start_date=${from}&end_date=${to}`)
    const getHistoryFarmasi = () => api.get(`${Constant.API_VERSION_1}/admin/pharmacy/production/history`)
    const getHistoryFarmasiByDate = (from, to) => api.get(`${Constant.API_VERSION_1}/admin/pharmacy/production/history?start_date=${from}&end_date=${to}`)
    const getPaymentHistory = () => api.get(`${Constant.API_VERSION_1}/admin/payment/monitoring/list?is_history=1`)
    const getPaymentHistoryByDate = (from, to) => api.get(`${Constant.API_VERSION_1}/admin/payment/history?date_from=${from}&date_to=${to}`)
    const getPaymentHistoryPaymentByDate = (from, to) => api.get(`${Constant.API_VERSION_1}/admin/payment/monitoring/list?is_history=1&date_filter={"created_at": {"start": "${from}", "end":"${to}"}}`)
    const getDetailPaymentHistory = (id) => api.get(`${Constant.API_VERSION_1}/admin/payment/monitoring/detail?id=${id}`)

    //RUNNING TEXT
    const getListRunningText = () => api.get(`${Constant.API_VERSION_1}/admin/running-text`)
    const getDetailRunningText = (id) => api.get(`${Constant.API_VERSION_1}/admin/running-text/detail?id=${id}`)
    const createRunningText = (body) => api.post(`${Constant.API_VERSION_1}/admin/running-text/create`, body)
    const updateRunningText = (body) => api.post(`${Constant.API_VERSION_1}/admin/running-text/edit`, body)

    // RESEP
    const getRecipe = () => api.get(`${Constant.API_VERSION_1}/admin/prescription`)
    const getDetailResep = (id) => api.get(`${Constant.API_VERSION_1}/admin/prescription/detail?id=${id}`)

    //NATIONAL HOLIDAY
    const getNationalHoliday = () => api.get(`${Constant.API_VERSION_1}/admin/setting/national-holiday`)
    const createNationalHoliday = (body) => api.post(`${Constant.API_VERSION_1}/admin/setting/national-holiday`, body)
    const getDetailHoliday = (id) => api.get(`${Constant.API_VERSION_1}/admin/setting/national-holiday/detail?id=${id}`)
    const updateNationalHoliday = (body) => api.post(`${Constant.API_VERSION_1}/admin/setting/national-holiday/edit`, body)

    // AMBULANCE
    const getListAmbulance = () => api.get(`${Constant.API_VERSION_1}/admin/master/ambulance/list`)
    const changeStatusAmbulance = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/ambulance/changestatus`, body)
    const createAmbulance = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/ambulance/create`, body)
    const getDetailAmbulance = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/ambulance/detail/${id}`)
    const updateAmbulance = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/ambulance/update`, body)

    // REPORT
    const LTPFacility = (params) => api.get(`${Constant.API_VERSION_1}/admin/report/lead-time-process/facility?${params}`)
    const LTPPharmacy = (params) => api.get(`${Constant.API_VERSION_1}/admin/report/lead-time-process/pharmacy-production?${params}`)
    const LTPDoctor = (params) => api.get(`${Constant.API_VERSION_1}/admin/report/lead-time-process/doctor?${params}`)
    const getUserLTP = () => api.get(`${Constant.API_VERSION_1}/admin/report/lead-time-process/filter/facility`)
    const getDokterLTP = () => api.get(`${Constant.API_VERSION_1}/admin/report/lead-time-process/filter/doctor`)
    const FilterMonitoringRuangan = (param) => api.get(`${Constant.API_VERSION_1}/admin/room/monitoring?${param}`)
    const FilterMonitoringRuanganKosong = (param) => api.get(`${Constant.API_VERSION_1}/admin/room/monitoring/unused?${param}`)
    const getMonitoringTransaksi = (floor) => api.get(`${Constant.API_VERSION_1}/admin/report/transaction/list?${floor}`)
    const getDetailMonitoringTransaksi = (id) => api.get(`${Constant.API_VERSION_1}/admin/report/transaction/detail?id=${id}`)
    const getMonitoringTransaksiAndDate = (body) => api.get(`${Constant.API_VERSION_1}/admin/report/transaction/list?${body}`)
    const getReportScheduleDoctor = () => api.get(`${Constant.API_VERSION_1}/admin/report/schedule/doctor`)
    const getReportScheduleDoctorByDate = (dateFrom, dateTo) => api.get(`${Constant.API_VERSION_1}/admin/report/schedule/doctor?start_date=${dateFrom}&end_date=${dateTo}`)
    const getCopyText = (id, tanggal) => api.get(`${Constant.API_VERSION_1}/admin/doctor/schedule/info?doctor_id=${id}&date=${tanggal}`)

    // EMERGENCY
    const getListOrder = () => api.get(`${Constant.API_VERSION_1}/admin/emergency/list`)
    const getDetailEmergency = (id) => api.get(`${Constant.API_VERSION_1}/admin/emergency/detail/${id}`)
    const getAmbulance = () => api.get(`${Constant.API_VERSION_1}/admin/ambulance/list/active`)
    const createOrder = (body) => api.post(`${Constant.API_VERSION_1}/admin/emergency/booking`, body)
    const updateEmergency = (body) => api.post(`${Constant.API_VERSION_1}/admin/emergency/update`, body)
    const getListPetugas = () => api.get(`${Constant.API_VERSION_1}/admin/emergency-officer`)
    const createPetugas = (body) => api.post(`${Constant.API_VERSION_1}/admin/emergency-officer/create`, body)
    const getDetailPetugas = (id) => api.get(`${Constant.API_VERSION_1}/admin/emergency-officer/detail?id=${id}`)
    const updatePetugas = (body) => api.post(`${Constant.API_VERSION_1}/admin/emergency-officer/edit`, body)

    // Telemedicine
    const getListMasterSpesialis = () => api.get(`${Constant.API_VERSION_1}/admin/specialities`)
    const createMasterSpesialis = (body) => api.post(`${Constant.API_VERSION_1}/admin/specialities/create`, body)
    const getDetailMasterSpesialis = (id) => api.get(`${Constant.API_VERSION_1}/admin/specialities/detail?id=${id}`)
    const updateMasterSpesialis = (body) => api.post(`${Constant.API_VERSION_1}/admin/specialities/edit`, body)
    const getListMasterDokter = () => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/list`)
    const getListMasterDokterFilter = (param) => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/list?${param}`)
    const createMasterDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/create`, body)
    const getDetailMasterDokter = (id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/detail?id=${id}`)
    const updateMasterDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/edit`, body)
    const getListMasterPriceDokter = () => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/price/list`)
    const createPriceDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/price/create`, body)
    const updateMasterHargaDokter = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/price/edit`, body)
    const getDetailMasterHargaDokter = (id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/price/detail?id=${id}`)
    const getMonitoringBiaya = () => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/cost/list`)
    const getMonitoringBiayaByDate = (start, end) => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/cost/list?date_filter={"telemedicine_date":{"start": "${start}", "end": "${end}"}}`)
    const getDetailMonitoringBiaya = (id) => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/cost/detail/${id}`)
    const getMonitoringReservasi = () => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/appointment/list`)
    const getMonitoringReservasiByDate = (start, end) => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/appointment/list?date_filter={"telemedicine_date":{"start": "${start}", "end": "${end}"}}`)
    const getDetailMonitoringReservasi = (id) => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/appointment/detail/${id}`)
    const getMonitoringOrder = () => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/order-transaction/list`)
    const getDetailMonitoringOrder = (id) => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/order-transaction/detail/${id}`)
    const getMonitoringOrderByDate = (start, end) => api.get(`${Constant.API_VERSION_1}/admin/telemedicine/monitoring/order-transaction/list?date_filter={"telemedicine_date":{"start": "${start}", "end": "${end}"}}`)
    const getMasterJadwalTelemedicine = () => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/schedule/master/list`)
    const createMasterJadwalTelemedicine = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/schedule/master/create`, body)
    const getDetailMasterJadwalTelemedicine = (id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/schedule/master/detail?id=${id}`)
    const editMasterJadwalTelemedicine = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/schedule/master/edit`, body)
    const createManualCronTelemed = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/schedule/manual`, body)
    const getJadwalTelemedicine = (id) => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/schedule/list?filter={"doctor_telemedicine_id": ${id}}`)
    const getJadwalTransaksiTelemedicine = () => api.get(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/schedule/list`)
    const createJadwalTelemedicine = (body) => api.post(`${Constant.API_VERSION_1}/admin/doctor/telemedicine/schedule/create`, body)

    // UPLOAD
    const uploadPreview = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/upload/preview`, body)
    const savePreview = (body) => api.post(`${Constant.API_VERSION_1}/admin/appointment/upload/save`, body)

    //MENU LAIN
    const getListMasukanSaran = () => api.get(`${Constant.API_VERSION_1}/admin/feedback/list`)
    const getListUlasan = () => api.get(`${Constant.API_VERSION_1}/admin/review/list`)

    const downloadAppointment = (param) => api.get(`${Constant.API_VERSION_1}/admin/appointment/report?${param}`)

    //BILL
    const createBill = (body) => api.post(`${Constant.API_VERSION_1}/admin/bill/manual`, body)
    const getListPaymentMethod = () => api.get(`${Constant.API_VERSION_1}/admin/payment/method/web?filter={"deleted_at": null}`)
    const createPayment = (body) => api.post(`${Constant.API_VERSION_1}/admin/payment/manual`, body)
    const cancelPayment = (body) => api.post(`${Constant.API_VERSION_1}/admin/payment/cancel`, body)
    const cancelBill = (body) => api.post(`${Constant.API_VERSION_1}/admin/bill/manual/cancel`, body)
    const voidPayment = (body) => api.post(`${Constant.API_VERSION_1}/admin/payment/void`, body)
    const getCategoryInsurance = () => api.get(`${Constant.API_VERSION_1}/admin/master/insurance/type`)
    const getInsuranceByCategory = (type) => api.get(`${Constant.API_VERSION_1}/admin/master/insurance?filter={"type": "${type}"}`)
    const getListSubFacilityByFacility = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/subfacility/code/list-by-facility?facility_id=${id}`)

    // MASTER ASURANSI
    const getListInsurance = () => api.get(`${Constant.API_VERSION_1}/admin/master/insurance`)
    const getListKategoriProvider = () => api.get(`${Constant.API_VERSION_1}/admin/master/insurance/type`)
    const createInsurance = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/insurance/create`, body)
    const getDetailInsurance = (id) => api.get(`${Constant.API_VERSION_1}/admin/master/insurance/detail/${id}`)
    const updateInsurance = (body) => api.post(`${Constant.API_VERSION_1}/admin/master/insurance/edit`, body)

    // LABORATORIUM
    const getListLaboratorium = () => api.get(`${Constant.API_VERSION_1}/admin/laboratory/production/list`)
    const getListHistoryLaboratorium = () => api.get(`${Constant.API_VERSION_1}/admin/laboratory/production/history`)
    const getDetailMonitoringLab = (id) => api.get(`${Constant.API_VERSION_1}/admin/laboratory/production/detail/${id}`)
    const changeStatusLab = (body) => api.post(`${Constant.API_VERSION_1}/admin/laboratory/production/changestatus`, body)

     // RADIOLOGI
     const getListRadiologi = () => api.get(`${Constant.API_VERSION_1}/admin/radiology/production/list`)
     const getListHistoryRadiologi = () => api.get(`${Constant.API_VERSION_1}/admin/radiology/production/history`)
     const getDetailMonitoringRadiologi = (id) => api.get(`${Constant.API_VERSION_1}/admin/radiology/production/detail/${id}`)
     const changeStatusRadiologi = (body) => api.post(`${Constant.API_VERSION_1}/admin/radiology/production/changestatus`, body)

     // GENARAL CONCENST
     const getListGeneralConcents = () => api.get(`${Constant.API_VERSION_1}/admin/general-consent/list`)
     const getListGeneralConcentsByDate = (dateFrom, dateTo) => api.get(`${Constant.API_VERSION_1}/admin/general-consent/list?date_filter={"created_at": {"start": "${dateFrom}", "end": "${dateTo}"}}`)
     const getDetailMonitoringGC = (id) => api.get(`${Constant.API_VERSION_1}/admin/general-consent/detail/${id}`)


    return {
        checkApiKey,
        login,
        logout,
        accessMenu,
        editMasterJadwal,
        getUser,
        updateUser,
        getUserDetail,
        getPaymentHistoryPaymentByDate,
        getJadwalTransaksiFilter,
        getAllHistory,
        getAllHistoryName,
        getAllHistoryNameByDate,
        getHistoryTransactionScrenning,
        updateScrenning,
        getAllHistoryByDate,
        getHistoryDoctor,
        getHistoryDoctorByPage,
        getHistoryDoctorByDate,
        getHistoryFarmasi,
        getHistoryFarmasiByDate,
        getPaymentHistory,
        getPaymentHistoryByDate,
        getDetailPaymentHistory,
        forgotPass,
        resetPass,
        getAllFacilityFilter,
        getPermission,
        getDetailHospital,
        addNotes,
        getListAsuransi,
        getListProvider,
        getCategoryProvider,
        getProviderByCategory,
        getProviderByCode,
        getDashboardTransaksi,
        getDashboardReview,
        getTNC,
        getDetailTNC,
        getPreviewTNC,
        createTNC,
        updateTNC,
        getPolicy,
        getDetailPolicy,
        getPreviewPolicy,
        createPolicy,
        updateScheduleFacility,
        updatePolicy,
        getCategoryFAQ,
        updateCategoryFAQ,
        getDetailCategoryFAQ,
        createCategoryFAQ,
        getCategoryFAQByType,
        createFAQ,
        getFAQ,
        getDetailFAQ,
        updateFAQ,
        getRoomFilter,
        getBuildingFilter,
        changeStatusUser,
        createUser,
        refreshToken,
        getListMasterPoliActive,
        getAkun,
        detailAkun,
        uploadFoto,
        createReservation,
        filterDokter,
        createMasterSchedule,
        getReservasiDokterFilter,
        getReservasiDokterByBookingID,
        getRoom,
        emergencyReservation,
        changeStatusProduksi,
        getListDokterFilter,
        getTimeslotDokter,
        getFormScrenning,
        editSchedulePoli,
        getDokterScheduleId,
        getScheduleTransactionFilterByDoctorID,
        getScheduleTransactionFilterName,
        getScheduleTransactionFilterNameAndDate,
        batalSessionDokter,
        getTimeSlot,
        editAkun,
        cancelReservation,
        createSessionPoli,
        checkPoliklinik,
        getPharmacyProduction,
        getPharmacyProductionByFacilityID,
        getDetailPharmacyProduction,
        updateCountPrint,
        getListPatientFilter,
        updateTemperature,
        getPembayaran,
        batalTransaksiJadwal,
        getPembayaranDetail,
        getMasterSchedule,
        getDetailReservasiDokter,
        getReservasiDokter,
        getTransactionScrenningFilter,
        updateSchedulePoli,
        getTransactionScrenningDetail,
        getSchedulePoliTransactionFilter,
        createRoom,
        reschedule,
        createPromo,
        submitScrenning,
        createSessionDokter,
        checkDokter,
        checkIn,
        getScrenning,
        filterReservasiDokter,
        getTransactionScrenning,
        getPharmacySession,
        getBuilding,
        createBuilding,
        getListSpesialis,
        getPromo,
        updateSession,
        createSpesialis,
        getSpesialisDokter,
        getListMasterPoli,
        getRoot,
        createPoli,
        createPoliSchedule,
        getListPatient,
        getScheduleTransaction,
        getScheduleTransactionFilter,
        getListSpesialisDokter,
        getListPoli,
        getPoliSchedule,
        getDetailPoli,
        getListDokter,
        getDetailDokter,
        createDokter,
        createDokterSchedule,
        getDokterScheduleByPoli,
        getDokterSchedule,
        getListMenu,
        getListRole,
        createRole,
        createPatient,
        getDetailPatient,
        updatePatient,
        getDetailRole,
        updateRole,
        changeStatusRole,
        updateListAntrian,
        getListAntrian,
        getListAntrianByPage,
        getDetailPasienPemanggilan,
        changeStatusPatient,
        searchPatientIntegration,
        searchPatientIntegrationByNoRM,
        updateDokter,
        getPemanggilanFacility,
        updateListPemanggilanFacility,
        getDetailPemanggilanFacility,
        updateListPemanggilanFacilityCounter,
        getListDokterPemanggilan,
        getListCounter,
        getListAllCounter,
        getListCounterByPage,
        getListCounterByFilter,
        getListCounterBySearch,
        getListSubFacility,
        getListSubFacilityByPage,
        getDetailListSubFacility,
        createManualCronFasilitas,
        getAllFacility,
        updateListPemanggilanSubFacilityCounter,
        createFacility,
        changeStatusFacility,
        updateFacility,
        getDetailFacility,
        createCounter,
        updateCounter,
        getDetailCounter,
        changeStatusQueueDisplay,
        changeStatusCounter,
        getAllSubFacility,
        getDetailSubFacility,
        createSubFacility,
        changeStatusSubFacility,
        updateSubFacility,
        getDokterByKeyword,
        getDokterByKeywordAndPoli,
        getFacilityCategory,
        createScrenning,
        getDetailScrenning,
        updateSessionDokter,
        getAllQueueDisplay,
        getDetailQueueDisplay,
        createQueueDisplay,
        updatePoli,
        getDetailRoom,
        changeStatusRoom,
        updateRoom,
        checkRoom,
        changeRoomSchedule,
        getDetailBuilding,
        updateBuilding,
        getFacilityByCategoriID,
        getSubFacilityByFacilityID,
        updateListPemanggilanSubFacility,
        getPemanggilanFacilitySkip,
        getPemanggilanSubFacilitySkip,
        getPemanggilanSubFacilitySkipByPage,
        getAllKioskDisplay,
        getDetailKiosk,
        updateKioskDisplay,
        createKioskDisplay,
        changeStatusKioskDisplay,
        getParameter,
        updateParameter,
        updateQueueDisplay,
        getListSessionFacilityByCategory,
        getListAntrianSkip,
        getListAntrianSkipByPage,
        getProfile,
        getDefaultSubFacility,
        getEksternalCodeSubFacility,
        getPromosi,
        createPromosi,
        getDetailPromosi,
        updatePromosi,
        getListRunningText,
        getDetailRunningText,
        createRunningText,
        updateRunningText,
        getListMedia,
        createMedia,
        getDetailMedia,
        updateMedia,
        createJadwalCuti,
        updateCatatanDokter,
        getLastScheduleDokter,
        getMasterDraftScheduleDokter,
        createMasterScheduleFromDraft,
        downloadScheduleDokter,
        getRecipe,
        getDetailResep,
        getNationalHoliday,
        createNationalHoliday,
        getDetailHoliday,
        updateNationalHoliday,
        notificationAntrian,
        getListAmbulance,
        changeStatusAmbulance,
        createAmbulance,
        getDetailAmbulance,
        updateAmbulance,
        LTPFacility,
        LTPPharmacy,
        LTPDoctor,
        getUserLTP,
        getListOrder,
        getDetailEmergency,
        getDokterLTP,
        FilterMonitoringRuangan,
        FilterMonitoringRuanganKosong,
        getMonitoringTransaksi,
        getDetailMonitoringTransaksi,
        getMonitoringTransaksiAndDate,
        getReportScheduleDoctor,
        getReportScheduleDoctorByDate,
        getAmbulance,
        createOrder,
        updateEmergency,
        getListMasterDokter,
        getListMasterDokterFilter,
        createMasterDokter,
        getDetailMasterDokter,
        getListMasterSpesialis,
        createMasterSpesialis,
        getDetailMasterSpesialis,
        updateMasterSpesialis,
        updateMasterDokter,
        getListMasterPriceDokter,
        createPriceDokter,
        getDetailMasterHargaDokter,
        updateMasterHargaDokter,
        getMonitoringBiaya,
        getMonitoringBiayaByDate,
        getDetailMonitoringBiaya,
        getMonitoringReservasi,
        getDetailMonitoringReservasi,
        getMonitoringOrder,
        getDetailMonitoringOrder,
        getMonitoringOrderByDate,
        getMonitoringReservasiByDate,
        getMasterJadwalTelemedicine,
        createMasterJadwalTelemedicine,
        getDetailMasterJadwalTelemedicine,
        editMasterJadwalTelemedicine,
        getListPetugas,
        createPetugas,
        getDetailPetugas,
        updatePetugas,
        uploadPreview,
        savePreview,
        getListMasukanSaran,
        getListUlasan,
        findCode,
        createManualCron,
        createManualCronHFIS,
        downloadAppointment,
        createBill,
        getListPaymentMethod,
        createPayment,
        cancelPayment,
        cancelBill,
        voidPayment,
        getDetailKuitansi,
        createManualCronTelemed,
        getJadwalTelemedicine,
        getJadwalTransaksiTelemedicine,
        createJadwalTelemedicine,
        getCopyText,
        editDraftScheduleDokter,
        createDraftScheduleDokter,
        getRoomFilterbyBuilding,
        getCategoryInsurance,
        getInsuranceByCategory,
        getNoRM,
        getListInsurance,
        getListKategoriProvider,
        createInsurance,
        getDetailInsurance,
        updateInsurance,
        getListLaboratorium,
        getListHistoryLaboratorium,
        getDetailMonitoringLab,
        changeStatusLab,
        getListRadiologi,
        getListHistoryRadiologi,
        getDetailMonitoringRadiologi,
        changeStatusRadiologi,
        getListSubFacilityByFacility,
        getLocationRegis,
        getListGeneralConcents,
        getListGeneralConcentsByDate,
        getDetailMonitoringGC,
        getPrintSEP,
        postUpdateSEP,
        getAppointmeentByDate,
        getScheduleSession
    }
}

export default {
    create
}